var PRIMARY_FONTS = {
  headerFont: "'Skintype Display', Georgia, TimesNewRoman, 'Times New Roman', Times, Baskerville, serif",
  baseFont: "'Skintype Text Medium', 'Century Gothic', CenturyGothic, AppleGothic, Verdana, sans-serif",
  monoFont: "'apercu mono', 'Lucida Console', Monaco, monospace"
};

export { PRIMARY_FONTS as default };
